<template>
    <img
        class="h-16 w-auto"
        src="/juleica_logo.svg"
        alt="Logo">
</template>

<script setup>

</script>